import { useState, useEffect } from 'react';
import { clsx } from 'clsx';

interface AvatarProps {
  avatarUrl?: string | null;
  displayName?: string;
  username?: string;
  alt: string;
  className?: string;
}

function getInitial(displayName?: string, username?: string): string {
  const fromDisplay = displayName?.trim();
  if (fromDisplay && fromDisplay.length > 0) {
    return fromDisplay.charAt(0).toUpperCase();
  }
  if (username && username.length > 0) {
    return username.charAt(0).toUpperCase();
  }
  return '?';
}

function Avatar({ avatarUrl, displayName, username, alt, className }: AvatarProps) {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
  }, [avatarUrl]);

  const showImage = Boolean(avatarUrl) && !imageError;
  const rootClasses = clsx(
    'overflow-hidden rounded-full flex-shrink-0',
    !showImage && 'flex items-center justify-center bg-surface-secondary text-sm',
    className,
  );

  if (showImage && avatarUrl) {
    return (
      <div className={rootClasses}>
        <img
          src={avatarUrl}
          alt={alt}
          className="h-full w-full object-cover"
          onError={() => setImageError(true)}
        />
      </div>
    );
  }

  const initial = getInitial(displayName, username);
  return (
    <div className={rootClasses} role="img" aria-label={alt}>
      <span className="text-copy-secondary" data-testid="avatar-initial" aria-hidden>
        {initial}
      </span>
    </div>
  );
}

export default Avatar;
